import React from "react";
import { 
    Background,
    SplitDiv,
    CatalogueTittle,
    CatalogueText,
    CatalogueButton,
    CatalogueImage,
    CatalogueImageLief
} from './styles';
import CatalogueImg from '../../assets/home/cataloguee.png';
import LeafImg from '../../assets/home/leaf.png';
import DownloadCatalogue from '../DownloadCatalogue';
import { useTranslation } from "react-i18next";

const Catalogue = () => {
    const { t } = useTranslation();

    return(
        <Background>
            <SplitDiv>
                <CatalogueTittle><em>{t("catalogue2024")} {new Date().getFullYear()}</em></CatalogueTittle>
                <CatalogueText>{t("downloadCatalogPdf")}</CatalogueText>
                <DownloadCatalogue>
                    <CatalogueButton>{t("download")}</CatalogueButton>
                </DownloadCatalogue>
            </SplitDiv>
            <SplitDiv>
                <CatalogueImage src={CatalogueImg} alt="Catalogue 2024" />
                <CatalogueImageLief src={LeafImg}/>
            </SplitDiv>
        </Background>
    )
}
export default Catalogue;
